package team.platforma.multiplatform_material_extension.ui.core.global_style

import androidx.compose.foundation.BorderStroke
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.ButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

object OutlineButtonColorScheme {
    var containerColor: Color? = null
    var contentColor: Color? = null
    var disabledContainerColor: Color? = null
    var disabledContentColor: Color? = null
    var borderStroke : BorderStroke? = null

    @Composable
    internal fun borderStroke() : BorderStroke {
        return borderStroke ?: ButtonDefaults.outlinedButtonBorder(true)
    }
}

@Composable
internal fun takeOutlineButtonColors(): ButtonColors {
    val global = OutlineButtonColorScheme
    val default = ButtonDefaults.outlinedButtonColors()
    return ButtonDefaults.buttonColors().define(global, default)
}


@Composable
private fun ButtonColors.define(
    global: OutlineButtonColorScheme,
    default: ButtonColors
): ButtonColors {
    return this.copy(
        containerColor = global.containerColor ?: default.containerColor,
        contentColor = global.contentColor ?: default.contentColor,
        disabledContainerColor = global.disabledContainerColor ?: default.disabledContainerColor,
        disabledContentColor = global.disabledContentColor ?: default.disabledContentColor
    )
}